import { inject, Injectable } from "@angular/core";
import { RealTimeDataStore } from "@app/services/store/real-time-data-store";
import { WebStompEntitySubscriber } from "@app/services/webstomp/web-stomp-entity-subscriber.service";
import { SorCodeOverride } from "@app/models/rest/sor-code-override";
import { SorCodeOverrideRestService } from "@app/services/hal/sor-code-override-rest.service";
import { HateoasResourceService } from "@lagoshny/ngx-hateoas-client";

@Injectable({ providedIn: "root" })
export class SorCodeOverrideStore extends RealTimeDataStore<SorCodeOverride> {
  constructor() {
    const sorCodeOverrideRestService = inject(SorCodeOverrideRestService);
    const webStompSubscriber = inject(WebStompEntitySubscriber);
    const hateoasResourceService = inject(HateoasResourceService);

    super(
      sorCodeOverrideRestService,
      webStompSubscriber,
      hateoasResourceService
    );
    super.subscribeToMessaging("SorCodeOverride");
  }
}
